<template>
    <div>
        <q-card
            flat
            bordered
            v-for="(appointment, index) in appointments"
            :key="index"
            class="q-mb-sm"
            v-if="appointments.length > 0"
        >
            <q-card-section class="q-pa-sm">
                <q-item>
                    <q-item-section avatar>
                        <q-icon name="account_circle" size="xl" />
                    </q-item-section>

                    <q-item-section>
                        <q-item-label style="font-size: 1.5rem">
                            {{ appointment.doctor }}
                        </q-item-label>

                        <q-item-label caption style="font-size: 1rem">
                            {{ appointment.appointmentTime }}
                        </q-item-label>

                        <q-item-label caption style="font-size: 1rem">
                            <span
                                :style="{
                                    color: appointment.appointmentColor,
                                }"
                            >
                                <b>{{ appointment.appointmentStatus }}</b>
                            </span>
                        </q-item-label>
                    </q-item-section>

                    <q-item-section side top style="padding-top: 2rem">
                        <q-item-label caption style="font-size: 1rem">
                            {{ appointment.location }}
                        </q-item-label>

                        <q-item-label
                            color="black"
                            caption
                            style="font-size: 1rem"
                        >
                            <b>{{ appointment.appointmentDate }}</b>
                        </q-item-label>

                        <q-item-label caption style="font-size: 1rem">
                            TYPE: {{ appointment.aptType }}
                        </q-item-label>
                    </q-item-section>
                </q-item>
            </q-card-section>
        </q-card>

        <div v-else style="display: flex; justify-content: center">
            <q-chip outline color="blue" square icon="info">
                You have no appointments scheduled.
            </q-chip>
        </div>
    </div>
</template>

<script>
import { onMounted, ref } from "vue";
import axios from "axios";
import { BASE_PATH } from "@/main";
export default {
    setup() {
        const appointments = ref([]);

        // pt-service/fetch-new-appointment

        onMounted(async () => {
            try {
                const patient = JSON.parse(localStorage.getItem("USER"));
                const { data } = await axios.get(
                    `${BASE_PATH}/fetch-scheduled-appointment`,
                    {
                        // params: { patientId: 212642 },
                        params: { patientId: patient.Id },
                    }
                );
                appointments.value = data.scheduledAppointment;
                console.log(data);
            } catch (err) {}
        });

        return { appointments };
    },
};
</script>
